import React, { useEffect } from "react";
import { Chart } from "react-google-charts";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { ClipLoader } from "react-spinners";

const DATA = [
  ["From", "To", "Waste"],
  ["PAPER-BOX CRAFT", "ABC Traders ", 2],

  ["XYZ Recyclers (PAPER - BOX CRAFT)", "Recycled", 2],
  ["PAPER-BOX CRAFT", "ABC Traders ", 2],
  ["ABC Traders  (PAPER - BOX CRAFT)", "XYZ Recyclers", 2],
  ["XYZ Recyclers (PAPER - BOX CRAFT)", "Recycled", 2],
  ["PET-BOTTLES", "ABC Traders ", 2.8],
  ["ABC Traders  (PET - BOTTLES)", "XYZ Recyclers", 2.8],
  ["XYZ Recyclers (PET - BOTTLES)", "Recycled", 2.8],
  ["PET-BOTTLES", "ABC Traders ", 4],
  ["ABC Traders  (PET - BOTTLES)", "XYZ Recyclers", 4],
];

// [

//   ["XYZ Recyclers (PET - BOTTLES)", "Recycled", 4],
//   ["PET-BOTTLES", "ABC Traders ", 8],
//   ["ABC Traders  (PET - BOTTLES)", "XYZ Recyclers", 8],
//   ["XYZ Recyclers (PET - BOTTLES)", "Recycled", 8],
//   ["PET-BOTTLES", "ABC Traders ", 6],
//   ["ABC Traders  (PET - BOTTLES)", "XYZ Recyclers", 6],
//   ["XYZ Recyclers (PET - BOTTLES)", "Recycled", 6],
//   ["PET-BOTTLES", "ABC Traders ", 4],
//   ["ABC Traders  (PET - BOTTLES)", "XYZ Recyclers", 4],
// ];

// const DATA = [
//   ["From", "To", "Waste"],
//   ["Food waste", "Clean Coimbatore Alliance", 200],
//   ["Clean Coimbatore Alliance", "Recycled", 1],
//   ["Clean Coimbatore Alliance", "Compost", 3],
//   ["Clean Coimbatore Alliance", "Landfill", 2],
//   ["Clean Coimbatore Alliance", "Upcycled", 1],
//   ["Food waste", "SK Traders", 7],
//   ["SK Traders", "Recycled", 1],
//   ["SK Traders", "Compost", 3],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Landfill", 2],
//   ["SK Traders", "Upcycled", 0],
// ];

export const options = {
  sankey: {
    node: {
      label: {
        color: "#000000",
        bold: true,
      },
      stroke: {
        color: "#000000",
        width: 2,
      },
      padding: 50,
      colors: [
        "#A8D5BA", // Light Green
        "#FFD59A", // Light Orange
        "#A8D0E6", // Light Blue
        "#D4A5A5", // Light Red
        "#F8E9A1", // Light Yellow
        "#C3B1E1", // Light Purple
        "#B2DFDB", // Light Cyan
        "#DCEDC8", // Light Lime
        "#FFE082", // Light Amber
        "#BBDEFB", // Light Indigo
      ],
      interactivity: true,
    },

    link: {
      colorMode: "gradient",
      color: {
        fill: "#fff", // Color of the link.
        fillOpacity: 1, // Transparency of the link.
        // stroke: "ccc", // Color of the link border.
        // strokeWidth: 1, // Thickness of the link border (default 0).
      },
      colors: [
        "#A8D5BA", // Light Green
        "#FFD59A", // Light Orange
        "#A8D0E6", // Light Blue
        "#D4A5A5", // Light Red
        "#F8E9A1", // Light Yellow
        "#C3B1E1", // Light Purple
        "#B2DFDB", // Light Cyan
        "#DCEDC8", // Light Lime
        "#FFE082", // Light Amber
        "#BBDEFB", // Light Indigo
      ],
    },
  },
};

const SankeyChart = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const { overview, overviewLoading } = useSelector((state) => state.analytics);
  const [data, setData] = React.useState([
    ["From", "To", "Waste"],
    ["Loading...", "", 1],
    ["Loading..", " ", 2],
  ]);

  useEffect(() => {
    if (!overview.flowChart) return;
    setData(overview.flowChart);
  }, [overview.flowChart]);


  console.log(overview.flowChart, 'dashboard')

  return (
    <div
      style={{ width: isMobile ? "100%" : "70%", height: "50vh" }}
      className="box "
    >
      <div className="flex space-between">
        <p className="bold"> Waste Flow Chart (MT)</p>

        <ClipLoader color={"#6f2da8"} loading={overviewLoading} size={10} />
      </div>
      {overview.flowChart?.length > 2 ? (
        <Chart
          chartType="Sankey"
          width="100%"
          height={"95%"}
          data={data}
          options={options}
        />
      ) : (
        <div className="flex align-center justify-center full-height">
          <div className="flex justify-center align-center colunn">
            <i className="material-icons">info</i>
            <p>No data available to be displayed</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SankeyChart;
